import React from 'react';
import useIntersectCallback from '@nykaa/utils/IObserver/useIntersectCallback';
import useIntersectOutCallback from '@nykaa/utils/IObserver/userIntersectOutCallback';
import { DEFAULT_ROOT_MARGIN } from '@nykaa/deals-utils/impressions/constants';
import { VIEWABLE_THRESHOLD } from '../../constants';
function Observer({ onIntersect, exitCallBack, children, onIntersectV2, className = '', childClassName = '', rootMargin = DEFAULT_ROOT_MARGIN, isV2Present = true, }) {
    const [setNodeToObserve] = useIntersectCallback({ rootMargin }, onIntersect);
    const [setNodeToObserveOut] = useIntersectOutCallback({}, VIEWABLE_THRESHOLD, onIntersectV2, exitCallBack);
    // handle case when in pw1 and pw2 no v2 required then no need of below
    const v2Ref = (isV2Present && { ref: setNodeToObserveOut });
    return (React.createElement("div", { ref: setNodeToObserve, style: { display: 'inherit' }, className: className },
        React.createElement("div", Object.assign({}, v2Ref, { style: { display: 'inherit' }, className: childClassName }), children)));
}
export default Observer;
